"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../../constants");
const WarningPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(3.000000, 3.000000)"
}, _react.default.createElement("path", {
  d: "M0.0924856821,14.9222409 L8.34281207,0.376786364 C8.62776803,-0.125595455 9.37223197,-0.125595455 9.65718793,0.376786364 L17.9075143,14.9222409 C18.1824369,15.4069337 17.8208013,16 17.2503264,16 L0.749673612,16 C0.179198693,16 -0.182436878,15.4069337 0.0924856821,14.9222409 Z"
}), _react.default.createElement("path", {
  d: "M10,12 L10,14 L8,14 L8,12 L10,12 Z M10,4 L10,10 L8,10 L8,4 L10,4 Z",
  fill: "#FFFFFF"
}))));
const WarningMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M23.865,20.9813068 L12.865,1.98130682 C12.6720668,1.69226777 12.3475152,1.51869318 12,1.51869318 C11.6524848,1.51869318 11.3279332,1.69226777 11.135,1.98130682 L0.135,20.9813068 C-0.0435414816,21.2905493 -0.0436392906,21.671529 0.134743384,21.9808631 C0.313126058,22.2901973 0.6429176,22.4809408 1,22.4813068 L23,22.4813068 C23.3570824,22.4809408 23.6868739,22.2901973 23.8652566,21.9808631 C24.0436393,21.671529 24.0435415,21.2905493 23.865,20.9813068 L23.865,20.9813068 Z M13.206,8.48130682 L12.733,15.0813068 L11.267,15.0813068 L10.821,8.48130682 L13.206,8.48130682 Z M12,19.4813068 C11.1897983,19.4813068 10.533,18.8245086 10.533,18.0143068 C10.533,17.2041051 11.1897983,16.5473068 12,16.5473068 C12.8102017,16.5473068 13.467,17.2041051 13.467,18.0143068 C13.467,18.8245086 12.8102017,19.4813068 12,19.4813068 Z"
})));
const AbstractWarning = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === _constants.THEMES.mds ? _react.default.createElement(WarningMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(WarningPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractWarning);